import {
  Card,
  Button,
  Input,
  Select,
  Form,
  Radio,
  Checkbox,
  Row,
  Col,
  Typography,
  Flex,
  Tag,
  Divider,
  Table,
  Alert,
  Space,
  Statistic,
} from "antd"
import {
  SaveOutlined,
  HomeOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  SafetyOutlined,
  FireOutlined,
  ToolOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  CompassOutlined,
  BuildOutlined,
  CalculatorOutlined,
  ThunderboltOutlined,
  AppstoreOutlined,
} from "@ant-design/icons"
import NumeralButton from "components/Common/NumeralButton"
import { serializeQuery } from "helpers/service_helper"
import React, { useState, useReducer, useEffect } from "react"
import { message } from "antd"

const { Title, Text } = Typography
const { TextArea } = Input

export const ProjectRequired = ({ rowData, mainProps }) => {
  const { lstGasProjectFiles } = mainProps

  const [sumTotalCount, dispatchSumTotalCount] = useReducer((state, action) => {
    return Number((state + action).toFixed(1))
  }, rowData.gasProjectDetail.totalCount)

  const [sumTotalUsage, dispatchSumTotalUsage] = useReducer((state, action) => {
    return Number((state + action).toFixed(1))
  }, rowData.gasProjectDetail.totalUsage)

  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      id: rowData.gasProjectDetail.id,
      consent: rowData.gasProjectDetail.consent,
      pipeSize: rowData.gasProjectDetail.pipeSize
        ? rowData.gasProjectDetail.pipeSize
        : 1,
      collectorSize: rowData.gasProjectDetail.collectorSize
        ? rowData.gasProjectDetail.collectorSize
        : 0,
      locationGasMeter: rowData.gasProjectDetail.locationGasMeter
        ? rowData.gasProjectDetail.locationGasMeter
        : "حیاط",
      desLocationGasMeter: rowData.gasProjectDetail.desLocationGasMeter,
      needSubCutter: rowData.gasProjectDetail.needSubCutter,
      windowsSealingStatus: rowData.gasProjectDetail.windowsSealingStatus
        ? rowData.gasProjectDetail.windowsSealingStatus
        : "هوابند",
      desWindowsSealing: rowData.gasProjectDetail.desWindowsSealing,
      gOvnCount: rowData.gasProjectDetail.gOvnCount,
      gOvnUsage: rowData.gasProjectDetail.gOvnUsage,
      gComCount: rowData.gasProjectDetail.gComCount,
      gComUsage: rowData.gasProjectDetail.gComUsage,
      hitterUsage: rowData.gasProjectDetail.hitterUsage,
      hitterCount: rowData.gasProjectDetail.hitterCount,
      whWaCount: rowData.gasProjectDetail.whWaCount,
      whWaUsage: rowData.gasProjectDetail.whWaUsage,
      whWaFanCount: rowData.gasProjectDetail.whWaFanCount,
      whWaFanUsage: rowData.gasProjectDetail.whWaFanUsage,
      whFlCount: rowData.gasProjectDetail.whFlCount,
      whFlUsage: rowData.gasProjectDetail.whFlUsage,
      pWaCount: rowData.gasProjectDetail.pWaCount,
      pWaUsage: rowData.gasProjectDetail.pWaUsage,
      pFlCount: rowData.gasProjectDetail.pFlCount,
      pFlUsage: rowData.gasProjectDetail.pFlUsage,
      pFaCount: rowData.gasProjectDetail.pFaCount,
      pFaUsage: rowData.gasProjectDetail.pFaUsage,
      pFaFactor: rowData.gasProjectDetail.pFaCount
        ? Number(
            (
              rowData.gasProjectDetail.pFaUsage /
              rowData.gasProjectDetail.pFaCount
            ).toFixed(1)
          )
        : 2.5,
      burnerCount: rowData.gasProjectDetail.burnerCount,
      burnerUsage: rowData.gasProjectDetail.burnerUsage,
      burnerFactor: rowData.gasProjectDetail.burnerCount
        ? Number(
            (
              rowData.gasProjectDetail.burnerUsage /
              rowData.gasProjectDetail.burnerCount
            ).toFixed(1)
          )
        : 0,
      rComCount: rowData.gasProjectDetail.rComCount,
      rComUsage: rowData.gasProjectDetail.rComUsage,
      rNormCount: rowData.gasProjectDetail.rNormCount,
      totalCount: rowData.gasProjectDetail.totalCount,
      totalUsage: rowData.gasProjectDetail.totalUsage,
      rNormUsage: rowData.gasProjectDetail.rNormUsage,
      autoGasCutOff: rowData.gasProjectDetail.autoGasCutOff,
      gasLeakWarning: rowData.gasProjectDetail.gasLeakWarning,
      gasCutOffExt: rowData.gasProjectDetail.gasCutOffExt,
      whpLocation: rowData.gasProjectDetail.whpLocation,
      rLocation: rowData.gasProjectDetail.rLocation,
      chDiameter: rowData.gasProjectDetail.chDiameter,
      veDimension: rowData.gasProjectDetail.veDimension,
      groupTypeEnum: rowData.gasProjectDetail.groupTypeEnum,
      geoTypeEnum: rowData.gasProjectDetail.geoTypeEnum,
      unitTypeEnum: rowData.gasProjectDetail.unitTypeEnum,
      description: rowData.gasProjectDetail.description,
    }
  )
  const [open, setOpen] = useState(false)
  const handleInput = evt => {
    const name = evt.target.name

    if (name.indexOf("Count") !== -1) dispatchSumTotalCount(-formInput[name])
    if (name.indexOf("Count") !== -1) dispatchSumTotalCount(+evt.target.value)

    if (name.indexOf("Usage") !== -1) dispatchSumTotalUsage(-formInput[name])
    if (name.indexOf("Usage") !== -1) dispatchSumTotalUsage(+evt.target.value)

    let newValue = evt.target.value
    if (newValue == "on") newValue = evt.target.checked

    if (evt.target.attributes?.type?.value === "text") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }
    if (evt.target.attributes?.type?.value === "number") newValue = +newValue
    if (evt.target.attributes?.type?.value === "radio") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }

    if (name == "geoTypeEnum") {
      if (+newValue == 0) {
        message.error("جهت جغرافیایی ملک را مشخص کنید.")
      }
    }
    if (name == "groupTypeEnum") {
      if (+newValue == 0) {
        message.error("گروه بندی ساختمان را مشخص کنید.")
      }
    }

    if (name === "gComCount") {
      const usageValue = Math.round(0.7 * newValue * 100) / 100
      setFormInput({ ["gComUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["gComUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "hitterCount") {
      const usageValue = Math.round(0.6 * newValue * 100) / 100
      setFormInput({ ["hitterUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["hitterUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "rNormCount") {
      const usageValue = Math.round(0.3 * newValue * 100) / 100
      setFormInput({ ["rNormUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["rNormUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "whFlCount") {
      const usageValue = Math.round(1.5 * newValue * 100) / 100
      setFormInput({ ["whFlUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["whFlUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "whWaCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["whWaUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["whWaUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "whWaFanCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["whWaFanUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["whWaFanUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "gOvnCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["gOvnUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["gOvnUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "rComCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["rComUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["rComUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "pFaCount") {
      const usageValue =
        Math.round(+formInput["pFaFactor"] * newValue * 100) / 100
      setFormInput({ ["pFaUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["pFaUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "pFaFactor") {
      const usageValue =
        Math.round(+formInput["pFaCount"] * newValue * 100) / 100
      setFormInput({ ["pFaUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["pFaUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "burnerCount") {
      const usageValue =
        Math.round(+formInput["burnerFactor"] * newValue * 100) / 100
      setFormInput({ ["burnerUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["burnerUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "burnerFactor") {
      const usageValue =
        Math.round(+formInput["burnerCount"] * newValue * 100) / 100
      setFormInput({ ["burnerUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["burnerUsage"])
      dispatchSumTotalUsage(usageValue)
    }

    setFormInput({ [name]: newValue })
  }
  const date1 = new Date(rowData.gasProject.julianRegisterDate)
  const date2 = new Date("2024-08-24")

  const [returnReadOnly, setReturnReadOnly] = useState(false)
  const [errors, setErrors] = useState({})


  const getInitialFormState = (rowData) => ({
    id: rowData.gasProjectDetail.id,
    gppId:rowData.id,
    consent: rowData.gasProjectDetail.consent,
    pipeSize: rowData.gasProjectDetail.pipeSize ? rowData.gasProjectDetail.pipeSize : 1,
    collectorSize: rowData.gasProjectDetail.collectorSize ? rowData.gasProjectDetail.collectorSize : 0,
    locationGasMeter: rowData.gasProjectDetail.locationGasMeter ? rowData.gasProjectDetail.locationGasMeter : "حیاط",
    desLocationGasMeter: rowData.gasProjectDetail.desLocationGasMeter,
    needSubCutter: rowData.gasProjectDetail.needSubCutter,
    windowsSealingStatus: rowData.gasProjectDetail.windowsSealingStatus ? rowData.gasProjectDetail.windowsSealingStatus : "هوابند",
    desWindowsSealing: rowData.gasProjectDetail.desWindowsSealing,
    gOvnCount: rowData.gasProjectDetail.gOvnCount,
    gOvnUsage: rowData.gasProjectDetail.gOvnUsage,
    gComCount: rowData.gasProjectDetail.gComCount,
    gComUsage: rowData.gasProjectDetail.gComUsage,
    hitterUsage: rowData.gasProjectDetail.hitterUsage,
    hitterCount: rowData.gasProjectDetail.hitterCount,
    whWaCount: rowData.gasProjectDetail.whWaCount,
    whWaUsage: rowData.gasProjectDetail.whWaUsage,
    whWaFanCount: rowData.gasProjectDetail.whWaFanCount,
    whWaFanUsage: rowData.gasProjectDetail.whWaFanUsage,
    whFlCount: rowData.gasProjectDetail.whFlCount,
    whFlUsage: rowData.gasProjectDetail.whFlUsage,
    pWaCount: rowData.gasProjectDetail.pWaCount,
    pWaUsage: rowData.gasProjectDetail.pWaUsage,
    pFlCount: rowData.gasProjectDetail.pFlCount,
    pFlUsage: rowData.gasProjectDetail.pFlUsage,
    pFaCount: rowData.gasProjectDetail.pFaCount,
    pFaUsage: rowData.gasProjectDetail.pFaUsage,
    pFaFactor: rowData.gasProjectDetail.pFaCount
      ? Number((rowData.gasProjectDetail.pFaUsage / rowData.gasProjectDetail.pFaCount).toFixed(1))
      : 2.5,
    burnerCount: rowData.gasProjectDetail.burnerCount,
    burnerUsage: rowData.gasProjectDetail.burnerUsage,
    burnerFactor: rowData.gasProjectDetail.burnerCount
      ? Number((rowData.gasProjectDetail.burnerUsage / rowData.gasProjectDetail.burnerCount).toFixed(1))
      : 0,
    rComCount: rowData.gasProjectDetail.rComCount,
    rComUsage: rowData.gasProjectDetail.rComUsage,
    rNormCount: rowData.gasProjectDetail.rNormCount,
    totalCount: rowData.gasProjectDetail.totalCount,
    totalUsage: rowData.gasProjectDetail.totalUsage,
    rNormUsage: rowData.gasProjectDetail.rNormUsage,
    autoGasCutOff: rowData.gasProjectDetail.autoGasCutOff,
    gasLeakWarning: rowData.gasProjectDetail.gasLeakWarning,
    gasCutOffExt: rowData.gasProjectDetail.gasCutOffExt,
    whpLocation: rowData.gasProjectDetail.whpLocation,
    rLocation: rowData.gasProjectDetail.rLocation,
    chDiameter: rowData.gasProjectDetail.chDiameter,
    veDimension: rowData.gasProjectDetail.veDimension,
    groupTypeEnum: rowData.gasProjectDetail.groupTypeEnum,
    geoTypeEnum: rowData.gasProjectDetail.geoTypeEnum,
    unitTypeEnum: rowData.gasProjectDetail.unitTypeEnum,
    description: rowData.gasProjectDetail.description,
  });

// Add this useEffect to update form when rowData changes
useEffect(() => {
  setFormInput(getInitialFormState(rowData));
}, [rowData]);


  useEffect(() => {
    const shouldForceViewOnly =
      rowData?.accepted === false || Number(rowData?.inspectionStatus ?? 0) > 1

    setReturnReadOnly(
      shouldForceViewOnly ||
        rowData.gasProjectDetail.gasProject.projectLevelEnum === 2 ||
        (rowData.projectLevel !== 1 && rowData.projectLevel !== 4)
    )
  }, [rowData])

  const handleSubmitForm = async () => {
    const { onUpdateGasProjectDetailsNew } = mainProps
    
    // Validation
    const newErrors = {}
    
    if (+formInput.geoTypeEnum === 0) {
      newErrors.geoTypeEnum = "جهت جغرافیایی ملک را مشخص کنید."
    }
    if (+formInput.groupTypeEnum === 0) {
      newErrors.groupTypeEnum = "گروه بندی ساختمان را مشخص کنید."
    }
    if ((+formInput.groupTypeEnum === 1 || +formInput.groupTypeEnum === 2) && +formInput.unitTypeEnum === 0) {
      newErrors.unitTypeEnum = "نوع آپارتمان در گروه بندی را مشخص کنید."
    }
    if (!formInput.desWindowsSealing || formInput.desWindowsSealing.trim() === "") {
      newErrors.desWindowsSealing = "توضیحات تعداد و محل نصب دریچه های تامین هوا را وارد کنید."
    }
    if (!formInput.chDiameter || formInput.chDiameter.trim() === "") {
      newErrors.chDiameter = "تعداد/قطر دودکش را وارد کنید."
    }
    if (!formInput.veDimension || formInput.veDimension.trim() === "") {
      newErrors.veDimension = "تعداد/ظرفیت اگزاست را وارد کنید."
    }
    
    setErrors(newErrors)
    
    if (Object.keys(newErrors).length > 0) {
      message.error("لطفاً فیلدهای ضروری را تکمیل کنید.")
      return
    }

    let mapToSave = {
      ...formInput,
      totalCount: sumTotalCount,
      totalUsage: sumTotalUsage,
      pipeSize: +formInput.pipeSize,
      collectorSize: +formInput.collectorSize,
      geoTypeEnum: +formInput.geoTypeEnum,
      groupTypeEnum: +formInput.groupTypeEnum,
      unitTypeEnum: +formInput.unitTypeEnum,
      consent: formInput.consent === "true" || formInput.consent === true,
      autoGasCutOff:
        formInput.autoGasCutOff === "true" || formInput.autoGasCutOff === true,
      gasCutOffExt:
        formInput.gasCutOffExt === "true" || formInput.gasCutOffExt === true,
      gasLeakWarning:
        formInput.gasLeakWarning === "true" ||
        formInput.gasLeakWarning === true,
      needSubCutter:
        formInput.needSubCutter === "true" || formInput.needSubCutter === true,
    }
    await onUpdateGasProjectDetailsNew({
      process: mapToSave,
      queryString: serializeQuery({ idFile: rowData.idFile }),
    })
  }

  // Select options
  const groupTypeOptions = [
    { value: 0, label: "نامشخص" },
    { value: 1, label: "مسکونی" },
    { value: 2, label: "عمومی" },
    { value: 3, label: "خاص" },
    { value: 4, label: "تلفیقی" },
  ]

  const unitTypeOptions = [
    { value: 0, label: "نامشخص" },
    { value: 1, label: "آپارتمان 1 واحدی" },
    { value: 2, label: "آپارتمان 2 تا 10 واحدی" },
    { value: 3, label: "آپارتمان 11 تا 30 واحدی" },
    { value: 4, label: "آپارتمان 31 واحدی به بالا" },
  ]

  const pipeSizeOptions = [
    { value: 1, label: "1" },
    { value: 1.25, label: "1-1/4" },
    { value: 1.5, label: "1-1/2" },
    { value: 2, label: "2" },
    { value: 2.5, label: "2-1/2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
  ]

  const collectorSizeOptions = [
    { value: 0, label: "ندارد" },
    { value: 1.25, label: "1-1/4" },
    { value: 1.5, label: "1-1/2" },
    { value: 2, label: "2" },
    { value: 2.5, label: "2-1/2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
  ]

  const geoTypeOptions = [
    { value: 0, label: "نامشخص" },
    { value: 1, label: "شمالی" },
    { value: 2, label: "جنوبی" },
    { value: 3, label: "شرقی" },
    { value: 4, label: "غربی" },
  ]

  const locationGasMeterOptions = [
    { value: "حیاط", label: "حیاط" },
    { value: "پارکینگ", label: "پارکینگ" },
    { value: "پاگرد", label: "پاگرد" },
    { value: "راهرو", label: "راهرو" },
    { value: "بیرون ملک", label: "بیرون ملک" },
    { value: "داخل مغازه", label: "داخل مغازه" },
  ]

  // Consumer table columns
  const consumerColumns = [
    {
      title: "مصرف کننده",
      dataIndex: "name",
      key: "name",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "count",
      width: 120,
    },
    {
      title: "مصرف",
      dataIndex: "rate",
      key: "rate",
      width: 100,
    },
    {
      title: "جمع",
      dataIndex: "total",
      key: "total",
      width: 80,
      render: (value) => <Tag color="blue">{value}</Tag>,
    },
  ]

  // Consumer table data
  const consumerData = [
    {
      key: "1",
      name: "اجاق گاز GC",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.gComCount}
          objName="gComCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "0.7",
      total: formInput.gComUsage,
    },
    {
      key: "2",
      name: "بخاری H",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.hitterCount}
          objName="hitterCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "0.6",
      total: formInput.hitterUsage,
    },
    {
      key: "3",
      name: "کباب پز RC",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.rNormCount}
          objName="rNormCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "0.3",
      total: formInput.rNormUsage,
    },
    {
      key: "4",
      name: "آبگرمکن زمینی WH",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.whFlCount}
          objName="whFlCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "1.5",
      total: formInput.whFlUsage,
    },
    {
      key: "5",
      name: "آبگرمکن دیواری WWH",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.whWaCount}
          objName="whWaCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "2.5",
      total: formInput.whWaUsage,
    },
    {
      key: "6",
      name: "آبگرمکن دیواری فن دار WWHF",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.whWaFanCount}
          objName="whWaFanCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "2.5",
      total: formInput.whWaFanUsage,
    },
    {
      key: "7",
      name: "اجاق گاز تجاری GCT",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.gOvnCount}
          objName="gOvnCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "2.5",
      total: formInput.gOvnUsage,
    },
    {
      key: "8",
      name: "پلوپز تجاری RCT",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.rComCount}
          objName="rComCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: "2.5",
      total: formInput.rComUsage,
    },
    {
      key: "9",
      name: "پکیج P",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.pFaCount}
          objName="pFaCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: (
        <NumeralButton
          lblName=""
          initValue={formInput.pFaFactor}
          objName="pFaFactor"
          changeValue={1}
          changeValueDecimal={0.1}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      total: formInput.pFaUsage,
    },
    {
      key: "10",
      name: "مشعل B",
      count: (
        <NumeralButton
          lblName=""
          initValue={formInput.burnerCount}
          objName="burnerCount"
          changeValue={1}
          changeValueDecimal={0}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      rate: (
        <NumeralButton
          lblName=""
          initValue={formInput.burnerFactor}
          objName="burnerFactor"
          changeValue={1}
          changeValueDecimal={0.1}
          callBack={handleInput}
          disabled={returnReadOnly}
        />
      ),
      total: formInput.burnerUsage,
    },
  ]

  // Get button text based on status
  const getButtonText = () => {
    if (rowData.gasProjectDetail.gasProject.projectLevelEnum === 2) {
      return "نقشه تایید شده"
    }
    if (rowData.projectLevel !== 1 && rowData.projectLevel !== 4) {
      return "الزامات توسط کارشناس مرحله طراحی قابل ویرایش است"
    }
    return "ذخیره الزامات"
  }

  return (
    <div>
      <Form layout="vertical" onFinish={handleSubmitForm}>
        {/* Warning Alert */}
        {lstGasProjectFiles.findIndex(x => x.fileTypeEnum == 11) === -1 &&
          date1 > date2 && (
            <Alert
              message={
                <Flex align="center" gap={8}>
                  <WarningOutlined />
                  <span>نقشه طراحی را ابتدا آپلود کنید</span>
                </Flex>
              }
              type="warning"
              showIcon={false}
              style={{ marginBottom: 16, borderRadius: 10 }}
            />
          )}

        {/* Building Classification Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <BuildOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              مشخصات ساختمان
            </Title>
            {returnReadOnly && (
              <Tag color="orange" style={{ marginRight: "auto" }}>
                فقط خواندنی
              </Tag>
            )}
          </Flex>

          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item 
                label="گروه بندی ساختمان" 
                style={{ marginBottom: 8 }}
                validateStatus={errors.groupTypeEnum ? "error" : ""}
                help={errors.groupTypeEnum}
              >
                <Select
                  value={formInput.groupTypeEnum}
                  onChange={(value) => {
                    handleInput({ target: { name: "groupTypeEnum", value, attributes: { type: { value: "number" } } } })
                    setErrors(prev => ({ ...prev, groupTypeEnum: undefined }))
                  }}
                  disabled={returnReadOnly}
                  options={groupTypeOptions}
                  style={{ width: "100%" }}
                  status={errors.groupTypeEnum ? "error" : ""}
                />
              </Form.Item>
            </Col>

            {(+formInput.groupTypeEnum === 1 || +formInput.groupTypeEnum === 2) && (
              <Col xs={24} sm={12} md={8}>
                <Form.Item 
                  label="نوع آپارتمان در گروه بندی" 
                  style={{ marginBottom: 8 }}
                  validateStatus={errors.unitTypeEnum ? "error" : ""}
                  help={errors.unitTypeEnum}
                >
                  <Select
                    value={formInput.unitTypeEnum}
                    onChange={(value) => {
                      handleInput({ target: { name: "unitTypeEnum", value, attributes: { type: { value: "number" } } } })
                      setErrors(prev => ({ ...prev, unitTypeEnum: undefined }))
                    }}
                    disabled={returnReadOnly}
                    options={unitTypeOptions}
                    style={{ width: "100%" }}
                    status={errors.unitTypeEnum ? "error" : ""}
                  />
                </Form.Item>
              </Col>
            )}

            <Col xs={24} sm={12} md={+formInput.groupTypeEnum === 1 || +formInput.groupTypeEnum === 2 ? 8 : 16}>
              <Form.Item label="نیاز به رضایت نامه محضری" style={{ marginBottom: 8 }}>
                <Radio.Group
                  value={formInput.consent}
                  onChange={(e) => {
                    handleInput({ target: { name: "consent", value: e.target.value, attributes: { type: { value: "radio" } } } })
                  }}
                  disabled={returnReadOnly}
                >
                  <Radio value={true}>بلی</Radio>
                  <Radio value={false}>خیر</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Pipe Settings Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <ToolOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              مشخصات لوله کشی
            </Title>
          </Flex>

          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item label="سایز لوله اصلی (اینچ)" style={{ marginBottom: 8 }}>
                <Select
                  value={formInput.pipeSize}
                  onChange={(value) => {
                    handleInput({ target: { name: "pipeSize", value, attributes: { type: { value: "number" } } } })
                  }}
                  disabled={returnReadOnly}
                  options={pipeSizeOptions}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item label="سایز کلکتور (اینچ)" style={{ marginBottom: 8 }}>
                <Select
                  value={formInput.collectorSize}
                  onChange={(value) => {
                    handleInput({ target: { name: "collectorSize", value, attributes: { type: { value: "number" } } } })
                  }}
                  disabled={returnReadOnly}
                  options={collectorSizeOptions}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item 
                label="جهت جغرافیایی ملک" 
                style={{ marginBottom: 8 }}
                validateStatus={errors.geoTypeEnum ? "error" : ""}
                help={errors.geoTypeEnum}
              >
                <Select
                  value={formInput.geoTypeEnum}
                  onChange={(value) => {
                    handleInput({ target: { name: "geoTypeEnum", value, attributes: { type: { value: "number" } } } })
                    setErrors(prev => ({ ...prev, geoTypeEnum: undefined }))
                  }}
                  disabled={returnReadOnly}
                  options={geoTypeOptions}
                  style={{ width: "100%" }}
                  status={errors.geoTypeEnum ? "error" : ""}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Meter Location Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <EnvironmentOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              محل اجرای کنتور
            </Title>
          </Flex>

          <Form.Item 
            label="محل اجرای کنتور - مطابق محل تعیین شده بر روی پلان" 
            style={{ marginBottom: 12 }}
          >
            <Radio.Group
              value={formInput.locationGasMeter}
              onChange={(e) => {
                handleInput({ target: { name: "locationGasMeter", value: e.target.value, attributes: { type: { value: "text" } } } })
              }}
              disabled={returnReadOnly}
            >
              <Space wrap>
                {locationGasMeterOptions.map((opt) => (
                  <Radio.Button key={opt.value} value={opt.value}>
                    {opt.label}
                  </Radio.Button>
                ))}
              </Space>
            </Radio.Group>
          </Form.Item>

          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12}>
              <Form.Item label="شیر قطع کن فرعی مورد نیاز است؟" style={{ marginBottom: 8 }}>
                <Radio.Group
                  value={formInput.needSubCutter}
                  onChange={(e) => {
                    handleInput({ target: { name: "needSubCutter", value: e.target.value, attributes: { type: { value: "radio" } } } })
                  }}
                  disabled={returnReadOnly}
                >
                  <Radio value={true}>بلی</Radio>
                  <Radio value={false}>خیر</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item label="وضعیت درزبندی پنجره ها" style={{ marginBottom: 8 }}>
                <Radio.Group
                  value={formInput.windowsSealingStatus}
                  onChange={(e) => {
                    handleInput({ target: { name: "windowsSealingStatus", value: e.target.value, attributes: { type: { value: "text" } } } })
                  }}
                  disabled={returnReadOnly}
                >
                  <Radio value="هوابند">هوابند</Radio>
                  <Radio value="درزدار">درزدار</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item 
                label="توضیحات تعداد و محل نصب دریچه های تامین هوا" 
                required
                style={{ marginBottom: 8 }}
                validateStatus={errors.desWindowsSealing ? "error" : ""}
                help={errors.desWindowsSealing}
              >
                <Input
                  value={formInput.desWindowsSealing ?? ""}
                  onChange={(e) => {
                    handleInput({ target: { name: "desWindowsSealing", value: e.target.value, attributes: { type: { value: "text" } } } })
                    setErrors(prev => ({ ...prev, desWindowsSealing: undefined }))
                  }}
                  disabled={returnReadOnly}
                  style={{ textAlign: "center" }}
                  status={errors.desWindowsSealing ? "error" : ""}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Consumers Table Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <FireOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              مصرف کننده ها
            </Title>
          </Flex>

          <Table
            columns={consumerColumns}
            dataSource={consumerData}
            pagination={false}
            size="small"
            bordered
            scroll={{ x: 400 }}
            style={{ marginBottom: 16 }}
          />

          {/* Summary Statistics */}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Card
                size="small"
                style={{
                  background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
                  borderRadius: 8,
                  border: "1px solid #667eea30",
                }}
              >
                <Statistic
                  title={<Text type="secondary">تعداد کل</Text>}
                  value={sumTotalCount}
                  prefix={<CalculatorOutlined style={{ color: "#667eea" }} />}
                  valueStyle={{ color: "#667eea", fontWeight: "bold" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12}>
              <Card
                size="small"
                style={{
                  background: "linear-gradient(135deg, #52c41a15 0%, #389e0d15 100%)",
                  borderRadius: 8,
                  border: "1px solid #52c41a30",
                }}
              >
                <Statistic
                  title={<Text type="secondary">مصرف کل</Text>}
                  value={sumTotalUsage}
                  prefix={<ThunderboltOutlined style={{ color: "#52c41a" }} />}
                  valueStyle={{ color: "#52c41a", fontWeight: "bold" }}
                  suffix="متر مکعب"
                />
              </Card>
            </Col>
          </Row>
        </Card>

        {/* Safety Equipment Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <SafetyOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              الزامات نصب تجهیزات ایمنی
            </Title>
          </Flex>

          <Row gutter={[12, 12]}>
            <Col xs={24}>
              <Space wrap size={[16, 8]}>
                <Checkbox
                  checked={formInput.gasLeakWarning ?? false}
                  onChange={(e) => {
                    handleInput({ target: { name: "gasLeakWarning", value: e.target.checked ? "on" : false, checked: e.target.checked, attributes: { type: { value: "checkbox" } } } })
                  }}
                  disabled={returnReadOnly}
                >
                  آشکارساز گاز طبیعی
                </Checkbox>
                <Checkbox
                  checked={formInput.gasCutOffExt ?? false}
                  onChange={(e) => {
                    handleInput({ target: { name: "gasCutOffExt", value: e.target.checked ? "on" : false, checked: e.target.checked, attributes: { type: { value: "checkbox" } } } })
                  }}
                  disabled={returnReadOnly}
                >
                  آشکارساز مونوکسید کربن
                </Checkbox>
                <Checkbox
                  checked={formInput.autoGasCutOff ?? false}
                  onChange={(e) => {
                    handleInput({ target: { name: "autoGasCutOff", value: e.target.checked ? "on" : false, checked: e.target.checked, attributes: { type: { value: "checkbox" } } } })
                  }}
                  disabled={returnReadOnly}
                >
                  شیر خودکار قطع گاز در زلزله
                </Checkbox>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Ventilation Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <AppstoreOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              دودکش و تهویه
            </Title>
          </Flex>

          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12}>
              <Form.Item 
                label="تعداد/قطر دودکش" 
                required 
                style={{ marginBottom: 8 }}
                validateStatus={errors.chDiameter ? "error" : ""}
                help={errors.chDiameter}
              >
                <Input
                  value={formInput.chDiameter ?? ""}
                  onChange={(e) => {
                    handleInput({ target: { name: "chDiameter", value: e.target.value, attributes: { type: { value: "text" } } } })
                    setErrors(prev => ({ ...prev, chDiameter: undefined }))
                  }}
                  disabled={returnReadOnly}
                  style={{ textAlign: "center" }}
                  status={errors.chDiameter ? "error" : ""}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item 
                label="تعداد/ظرفیت اگزاست" 
                required 
                style={{ marginBottom: 8 }}
                validateStatus={errors.veDimension ? "error" : ""}
                help={errors.veDimension}
              >
                <Input
                  value={formInput.veDimension ?? ""}
                  onChange={(e) => {
                    handleInput({ target: { name: "veDimension", value: e.target.value, attributes: { type: { value: "text" } } } })
                    setErrors(prev => ({ ...prev, veDimension: undefined }))
                  }}
                  disabled={returnReadOnly}
                  style={{ textAlign: "center" }}
                  status={errors.veDimension ? "error" : ""}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Description Card */}
        <Card
          style={{
            borderRadius: 12,
            marginBottom: 16,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex align="center" gap={8} style={{ marginBottom: 16 }}>
            <FileTextOutlined style={{ fontSize: 18, color: "#667eea" }} />
            <Title level={5} style={{ margin: 0 }}>
              توضیحات
            </Title>
          </Flex>

          <Form.Item style={{ marginBottom: 0 }}>
            <TextArea
              value={formInput.description ?? ""}
              onChange={(e) => {
                handleInput({ target: { name: "description", value: e.target.value, attributes: { type: { value: "text" } } } })
              }}
              disabled={returnReadOnly}
              rows={3}
              style={{ borderRadius: 8 }}
              placeholder="توضیحات تکمیلی..."
            />
          </Form.Item>
        </Card>

        {/* Submit Card */}
        <Card
          style={{
            borderRadius: 12,
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex justify="flex-start" align="center" gap={12} wrap="wrap">
            {mainProps.loading ? (
              <Button
                type="primary"
                loading
                style={{
                  borderRadius: 8,
                  paddingInline: 24,
                  height: 40,
                }}
              >
                در حال ذخیره...
              </Button>
            ) : (
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                disabled={mainProps.loading || returnReadOnly}
                style={{
                  borderRadius: 8,
                  paddingInline: 24,
                  height: 40,
                  background:
                    returnReadOnly
                      ? undefined
                      : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  boxShadow:
                    returnReadOnly
                      ? undefined
                      : "0 4px 12px rgba(102, 126, 234, 0.4)",
                }}
              >
                {getButtonText()}
              </Button>
            )}

            {returnReadOnly && (
              <Tag
                color="orange"
                style={{
                  padding: "6px 12px",
                  borderRadius: 8,
                  fontSize: 12,
                }}
              >
                <InfoCircleOutlined style={{ marginLeft: 4 }} />
                امکان ویرایش وجود ندارد
              </Tag>
            )}
          </Flex>
        </Card>
      </Form>
    </div>
  )
}
